import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

const api = axios.create({
    baseURL: API_BASE_URL
});

// Response Interceptor for global error handling
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 409) {
            // Mix-related 409s are handled by the mix store with a refresh option
            const url = error.config?.url || '';
            const isMixRoute = url.startsWith('/mixes');
            const isSetlistRoute = url.startsWith('/setlists');
            const isNameConflict = (url.includes('/bands') && error.config?.method === 'post' && !url.includes('invite'))
                || url.includes('/users/me') || url.includes('/users/profile');
            if (!isMixRoute && !isSetlistRoute && !isNameConflict) {
                const { useUiStore } = await import('./stores/uiStore')
                const uiStore = useUiStore()

                const message = error.response.data || 'This action was blocked because another user is currently editing this resource.'
                const isVersion = message.toLowerCase().includes('modified') || message.toLowerCase().includes('version')

                uiStore.triggerConcurrencyError(message, isVersion)
            }
        }
        return Promise.reject(error);
    }
);

export default api;
